<template>
  <div class="home-container">
    <div class="carousel-container">
      <Carousel :carouselData="homeCarData" />
    </div>
    <div id="about" class="company-profile global-container">
      <div class="development-title" v-reveal>
        <GenericTitle
          :chineseText="IntroduChinese"
          :englishText="IntroduEnglish"
        />
      </div>
      <div class="brief" v-reveal="120">
        <div class="brief-text">
          <p>
            启愉智能（INSPIRER）是以研发制造 AI 智能养鱼系统为主的科技创新型企业，
            致力为新手零基础养鱼、发烧友轻松托管，提供智慧产品和生态服务，
            并实现水族 / 水产养护的科学、轻松、共赢的未来。
          </p>
          <div class="brief-tags">
            <span v-for="(t, i) in briefTags" :key="i">{{ t }}</span>
          </div>
        </div>
        <div
          class="brief-img"
          :style="{ backgroundImage: `url(${oss('启愉.png')})` }"
        ></div>
      </div>
    </div>
    <div class="stats-showcase">
      <div class="experience-container">
        <div
          class="experience-item"
          v-for="(exp, index) in aboutData"
          :key="index"
          v-reveal="index * 90"
        >
          <div class="num">{{ exp.num }}</div>
          <div class="title">{{ exp.title }}</div>
        </div>
      </div>
      <div class="physical-container" v-reveal>
        <testBnner />
      </div>
    </div>
    <div id="history" class="development-container">
      <div class="development-title" v-reveal>
        <GenericTitle
          :chineseText="develuChinese"
          :englishText="develuEnglish"
        />
      </div>
      <div class="timeline" ref="timelineRef" :class="{ visible: tlVisible }">
        <svg
          class="tl-svg"
          viewBox="0 0 1200 420"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="tlGrad" x1="0" y1="0" x2="1" y2="0.6">
              <stop offset="0" stop-color="#0c63b5" />
              <stop offset="0.55" stop-color="#1f7ac0" />
              <stop offset="1" stop-color="#ff6900" />
            </linearGradient>
          </defs>
          <!-- 浅色底轨 -->
          <path
            class="tl-track"
            fill="none"
            stroke="#dfe5ec"
            stroke-width="3"
            stroke-linecap="round"
            d="M 150 70 H 1050 A 115 115 0 0 1 1050 300 H 150"
          />
          <!-- 入场绘制的主轨 -->
          <path
            id="tlPath"
            class="tl-path"
            fill="none"
            stroke="url(#tlGrad)"
            stroke-width="3"
            stroke-linecap="round"
            pathLength="1000"
            d="M 150 70 H 1050 A 115 115 0 0 1 1050 300 H 150"
          />
          <!-- 沿线流动的高光（替代游离光点） -->
          <path
            class="tl-flow"
            fill="none"
            stroke="#ff8a3c"
            stroke-width="4"
            stroke-linecap="round"
            pathLength="1000"
            d="M 150 70 H 1050 A 115 115 0 0 1 1050 300 H 150"
          />
        </svg>
        <div
          class="node"
          v-for="(dev, index) in historyData"
          :key="index"
          :class="index < 4 ? 'top' : 'bottom'"
          :style="nodePos(index)"
        >
          <span class="dot" :class="{ accent: index % 2 === 1 }"></span>
          <div class="date">{{ dev.date }}</div>
          <div class="title">{{ dev.title }}</div>
        </div>
      </div>
    </div>
    <div id="products" class="products-container">
      <div class="development-title" :style="{ marginTop: '100px' }" v-reveal>
        <GenericTitle :chineseText="prdChinese" :englishText="prdEnglish" />
      </div>
      <div class="introduce-item">
        <div
          class="introduce-container"
          v-for="(item, index) in introductionData"
          :key="index"
          v-reveal="index * 120"
        >
          <div class="thumb">
            <div
              class="bg"
              :style="{ backgroundImage: `url(${item.image})` }"
            ></div>
          </div>
          <div class="content">
            <h2>{{ item.describe.title }}</h2>
            <p>{{ item.describe.introduction }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="system" class="system-container">
      <div class="development-title" v-reveal>
        <GenericTitle chineseText="数智养鱼系统" englishText="Smart Aquaculture System" />
      </div>
      <div class="system-layers">
        <div
          class="layer"
          v-for="(layer, index) in systemData"
          :key="index"
          v-reveal="index * 120"
        >
          <div class="layer-index">0{{ index + 1 }}</div>
          <div class="layer-head">
            <span class="layer-name">{{ layer.name }}</span>
            <span class="layer-sub">{{ layer.sub }}</span>
          </div>
          <div class="layer-tags">
            <span class="tag" v-for="(t, ti) in layer.items" :key="ti">{{ t }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-container">
      <p v-reveal>一次智能选择 · 十年轻松养鱼</p>
      <p v-reveal="120">AI 智能养鱼系统 · 开启轻松养鱼新体验</p>
    </div>
    <div class="footerInfo-contact">
      <FooterInfo />
    </div>
  </div>
</template>
<script setup lang="ts" name="Home">
import { oss } from "@/utils/oss";
import Carousel from "../components/Carousel.vue";
import FooterInfo from "../components/FooterInfo.vue";
import testBnner from "../components/testBnner.vue";
import GenericTitle from "../components/GenericTitle.vue";
import { reactive, ref, onMounted, onBeforeUnmount } from "vue";
const homeCarData = reactive([
  {
    image: oss("home/Maskgroup@1.png"),
    altText: "启愉智能鱼缸",
    describe: {
      title: "启愉智能鱼缸",
      introduction:
          "一次智能选择，十年轻松养鱼。启愉智能以 AI 智能养鱼系统为核心，让新手零基础也能轻松养好鱼。",
    },
  },
  {
    image: oss("home/Maskgroup@2.png"),
    altText: "启愉智慧鱼池",
    describe: {
      title: "启愉智慧鱼池",
      introduction:
          "面向别墅、会所等场景，提供定制化智慧鱼池方案，实时监测、智能换水、自清洁滤棉，尽享轻松养护。",
    },
  },
  {
    image: oss("home/Group632@3x.png"),
    altText: "启愉智慧配件",
    describe: {
      title: "启愉智慧配件",
      introduction:
          "智控照明、无级调控水泵、自适应喂食器、双温控加热棒等高性价比智慧配件，为轻松养鱼全面赋能。",
    },
  },
]);
const introductionData = reactive([
  {
    image: oss("qiyu/cloud.png"),
    describe: {
      title: "物联网科技",
      introduction:
          "共建鱼 / 粮 / 药 / 服务的全生态资源，提供实时精准的养护治疗方案，打造一站式生态。",
    },
  },
  {
    image: oss("qiyu/network.png"),
    describe: {
      title: "AIoT 集成系统",
      introduction:
          "AIoT 集成系统 + 创新维生结构，以轻松养鱼的产品解决客户痛点、推动市场增长。",
    },
  },
  {
    image: oss("qiyu/dashboard.png"),
    describe: {
      title: "数据 AI 赋能",
      introduction:
          "以数据采集、算法模型赋能同行产品开发、生态服务和产品营销，推动行业数智升级。",
    },
  },
]);
const aboutData = ref([
  {
    num: "500ms",
    title: "水质监测频次",
  },
  {
    num: "8s",
    title: "换水 + 清洁",
  },
  {
    num: "<10%",
    title: "新手死亡率",
  },
  {
    num: ">61%",
    title: "客户复购率",
  },
]);
const historyData = ref([
  {
    date: "2016.10",
    title: "生产工厂成立",
  },
  {
    date: "2020.11",
    title: "智能鱼缸项目启动",
  },
  {
    date: "2021.10",
    title: "长城杯国际水族展",
  },
  {
    date: "2023.06",
    title: "集成系统迭代发布",
  },
  {
    date: "2023.08",
    title: "获得天使轮投资",
  },
  {
    date: "2024.05",
    title: "大数据管理平台",
  },
  {
    date: "2025.03",
    title: "首例 AI 图像识别",
  },
  {
    date: "2025.11",
    title: "亚太宠物展 + 国际水族展",
  },
]);
const briefTags = reactive([
  "天使轮投资",
  "广州市专精特新产业园",
  "广东省重点建设项目",
  "广州市科技企业孵化器",
  "番禺百亿工程重点项目",
]);
const systemData = reactive([
  {
    name: "硬件执行",
    sub: "提供轻松养鱼体验",
    items: ["智能换水", "过滤清洁", "自动困水", "双重温控", "灯光模拟", "盐度调节"],
  },
  {
    name: "软件服务",
    sub: "提供一站式生态",
    items: ["远程控制", "生态商城", "销售裂变", "客户服务"],
  },
  {
    name: "数据 AI 赋能",
    sub: "提供智慧养鱼赋能",
    items: ["数据监测", "用户习惯", "水质趋势", "视觉采集", "数据分析", "科学决策", "精准需求"],
  },
]);
// 发展历程 S 形时间轴：节点定位 + 滚动入场
const cols = [150, 450, 750, 1050];
const nodePos = (i: number) => {
  const x = i < 4 ? cols[i] : cols[7 - i];
  const top = i < 4 ? 70 : 300; // 对应 SVG 路径两行的 y
  return { left: `${x}px`, top: `${top}px` };
};
const timelineRef = ref<HTMLElement | null>(null);
const tlVisible = ref(false);
let tlObserver: IntersectionObserver | null = null;
onMounted(() => {
  if (timelineRef.value) {
    tlObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) tlVisible.value = true;
        });
      },
      { threshold: 0.25 }
    );
    tlObserver.observe(timelineRef.value);
  }
});
onBeforeUnmount(() => tlObserver?.disconnect());

const IntroduChinese = "企业简介";
const IntroduEnglish = "About us";
const develuChinese = "发展历程";
const develuEnglish = "History";
const prdChinese = "产品与服务";
const prdEnglish = "Introduction";
</script>
<style scoped lang="scss">
.home-container {
  background-color: #f7f7f7;
  overflow: hidden;

  .carousel-container {
    width: 100%;
    height: 696px;
    margin-top: 60px;
  }
  .company-profile {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 90px;
    padding-bottom: 60px;
    .brief {
      width: 100%;
      margin-top: 56px;
      display: flex;
      justify-content: space-between;
      gap: 48px;
      .brief-text {
        flex: 1;
        text-align: left;
        p {
          font-size: 18px;
          line-height: 36px;
          color: $text-sub;
          margin: 0;
        }
        .brief-tags {
          margin-top: 28px;
          display: flex;
          flex-wrap: wrap;
          gap: 14px;
          span {
            padding: 8px 18px;
            border: 1px solid $primary;
            border-radius: 30px;
            font-size: 15px;
            color: $primary;
          }
        }
      }
      .brief-img {
        width: 520px;
        height: 312px;
        flex-shrink: 0;
        border-radius: 12px;
        background-size: cover;
        background-position: center;
      }
    }
  }
  // 数据 + 展示：全宽白色背景，内容宽度对齐上方企业简介（1200）
  .stats-showcase {
    width: 100%;
    background: #ffffff;
    padding: 72px 0 90px;
  }
  .experience-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 64px;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .experience-item {
      text-align: left;
      .num {
        font-family: $font-number;
        font-weight: 600;
        font-size: 56px;
        letter-spacing: 0.5px;
        color: #1a1a1a;
        line-height: 1.1;
      }
      .title {
        font-family: $font-body;
        font-weight: 400;
        font-size: 20px;
        color: #606163;
        line-height: 1.2;
        margin-top: 14px;
      }
    }
  }
  .physical-container {
    width: 100%;
  }
  .development-container {
    width: 100%;
    background-image: url("#{$oss}home/development.png");
    background-size: cover;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding-bottom: 110px;
    .development-title {
      margin-top: 100px;
      display: inline-block;
    }
    .timeline {
      position: relative;
      width: 1200px;
      height: 420px;
      margin-top: 60px;

      .tl-svg {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        overflow: visible;
      }
      // 浅色底轨：始终可见，给主轨一个落点
      .tl-track {
        opacity: 0.9;
      }
      // 主轨：入场时从头到尾匀速绘制（匀速才能和节点出现进度对齐）
      .tl-path {
        stroke-dasharray: 1000;
        stroke-dashoffset: 1000;
        transition: stroke-dashoffset 2.4s linear;
      }
      // 沿线流动的高光：入场前隐藏
      .tl-flow {
        stroke-dasharray: 90 910;
        stroke-dashoffset: 1000;
        opacity: 0;
        filter: drop-shadow(0 0 6px rgba(255, 138, 60, 0.85));
      }

      .node {
        position: absolute;
        width: 220px;
        transform: translateX(-50%);
        text-align: center;
        // 入场前
        opacity: 0;
        translate: 0 18px;
        transition: opacity 0.5s ease, translate 0.5s ease;

        .dot {
          position: relative;
          display: block;
          width: 18px;
          height: 18px;
          margin: 0 auto;
          transform: translateY(-50%);
          border-radius: 50%;
          background: $primary;
          border: 3px solid #ffffff;
          box-shadow: 0 0 0 3px rgba(12, 99, 181, 0.25);
          transition: box-shadow 0.25s, transform 0.25s;
          &.accent {
            background: $accent;
            box-shadow: 0 0 0 3px rgba(255, 105, 0, 0.25);
          }
        }
        .date {
          font-family: $font-number;
          font-weight: 600;
          font-size: 28px;
          letter-spacing: 0.5px;
          color: $text-main;
          line-height: 1.2;
          margin-top: 10px;
          transition: color 0.25s;
        }
        .title {
          font-family: $font-body;
          font-weight: 400;
          font-size: 16px;
          color: $text-sub;
          line-height: 24px;
          margin-top: 12px;
        }
        &:hover {
          .dot {
            transform: translateY(-50%) scale(1.25);
            box-shadow: 0 0 0 5px rgba(12, 99, 181, 0.18);
            &.accent {
              box-shadow: 0 0 0 5px rgba(255, 105, 0, 0.18);
            }
          }
          .date {
            color: $primary;
          }
        }
      }

      // ===== 入场后 =====
      &.visible {
        .tl-path {
          stroke-dashoffset: 0;
        }
        .tl-flow {
          opacity: 0.95;
          animation: tlFlow 4.5s linear 2.2s infinite;
        }
        .node {
          opacity: 1;
          translate: 0 0;
        }
        // 节点随线条绘制进度同步浮现：
        // 延迟 = 节点在路径上的弧长占比 × 绘制时长（上排 900 + 半圆弧 361 + 下排 900）
        $tl-draw: 2.4;
        $tl-fracs: 0, 0.139, 0.278, 0.416, 0.584, 0.722, 0.861, 1;
        @for $i from 1 through 8 {
          .node:nth-child(#{$i + 1}) {
            transition-delay: #{nth($tl-fracs, $i) * $tl-draw}s;
          }
        }
      }
    }
  }
  // 高光沿整条路径平滑流动
  @keyframes tlFlow {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  .products-container {
    width: 100%;
    height: 762px;
    background: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-family: $font-body;
    .products-title {
      margin-top: 100px;
    }
    .introduction-title {
      margin-top: 12px;
    }
    .introduce-item {
      display: flex;
      justify-content: center;
      gap: 28px;
      // 浅色产品卡：图在上、白底深字，与上方深色沉浸卡形成差异
      .introduce-container {
        width: 380px;
        margin-top: 40px;
        background: #ffffff;
        border: 1px solid #eef1f5;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(12, 99, 181, 0.07);
        transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1),
          box-shadow 0.4s ease;
        display: flex;
        flex-direction: column;

        .thumb {
          height: 210px;
          overflow: hidden;
          .bg {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            transition: transform 0.6s ease;
          }
        }
        .content {
          flex: 1;
          padding: 26px 26px 30px;
          text-align: left;
          h2 {
            position: relative;
            font-family: $font-title;
            font-weight: bold;
            font-size: 22px;
            color: $text-main;
            margin: 0 0 14px;
            padding-left: 14px;
            // 左侧品牌色竖条
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 4px;
              width: 4px;
              height: 20px;
              background: $accent;
            }
          }
          p {
            font-weight: 400;
            font-size: 15px;
            color: $text-sub;
            line-height: 28px;
            margin: 0;
          }
        }
        // 交互：卡片上浮 + 图片轻微放大
        &:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 44px rgba(12, 99, 181, 0.16);
          .thumb .bg {
            transform: scale(1.06);
          }
        }
      }
    }
  }
  .system-container {
    width: 100%;
    padding: 100px 0;
    background: $bg-soft;
    display: flex;
    flex-direction: column;
    align-items: center;
    .system-layers {
      width: 1200px;
      margin-top: 56px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      .layer {
        position: relative;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 6px 24px rgba(12, 99, 181, 0.06);
        padding: 30px 40px 30px 44px;
        display: flex;
        align-items: center;
        overflow: hidden;
        transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
          box-shadow 0.35s ease;
        // 左侧渐变强调条
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 6px;
          background: linear-gradient(180deg, $primary, $primary-dark);
          transition: width 0.3s ease;
        }
        .layer-index {
          flex-shrink: 0;
          width: 78px;
          font-family: $font-number;
          font-size: 38px;
          font-weight: bold;
          line-height: 1;
          color: $primary;
          opacity: 0.18;
        }
        .layer-head {
          width: 210px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          text-align: left;
          .layer-name {
            font-family: $font-title;
            font-size: 26px;
            font-weight: bold;
            color: $text-main;
          }
          .layer-sub {
            font-size: 14px;
            color: $text-muted;
            margin-top: 6px;
          }
        }
        .layer-tags {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          gap: 14px;
          .tag {
            padding: 9px 20px;
            background: #f4f7fb;
            border: 1px solid transparent;
            border-radius: 30px;
            font-size: 15px;
            color: $text-sub;
            transition: all 0.25s ease;
            &:hover {
              background: $primary-light;
              border-color: $primary;
              color: $primary;
            }
          }
        }
        // 第二行（软件服务）：橙色主题
        &:nth-child(2) {
          &::before {
            background: linear-gradient(180deg, $accent, $accent-dark);
          }
          .layer-index {
            color: $accent;
          }
          .layer-tags .tag:hover {
            background: #ffe9d9;
            border-color: $accent;
            color: $accent;
          }
        }
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 38px rgba(12, 99, 181, 0.14);
          &::before {
            width: 10px;
          }
        }
      }
    }
  }
  .banner-container {
    width: 100%;
    height: 250px;
    background-image: url("#{$oss}home/Maskgroup@3x.png");
    background-size: cover;
    font-family: $font-body;
    font-size: 32px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 190px;
  }
  .footerInfo-contact {
    width: 100%;
    height: 440px;
  }
}
</style>
